import { Alert, Typography } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';
import { useMemo } from 'react';

import { useAgGridClientTableContext } from 'core/states';
import { QuotePartHelper } from 'quotes/helpers';
import { IQuotePart } from 'quotes/types';
import { Color, Level, Size, Variant } from 'theme/enums';

// Nightly accrual window (869fg3r09, temporary): shown while at least one loaded line was left
// without a cost because the pricing engine is paused. It goes away on the first read after the
// window ends or once the lines are recalculated — the BE derives the flag on every read.
export const QuotePartPricingWindowBanner = () => {
  const { rows } = useAgGridClientTableContext();

  const message = useMemo(() => QuotePartHelper.pricingWindowBanner(rows as IQuotePart[]), [rows]);

  if (!message) {
    return null;
  }

  return (
    <Alert
      role="alert"
      startDecorator={<Warning style={{ width: 24, height: 24 }} />}
      variant={Variant.SOFT}
      color={Color.WARNING}
      size={Size.LG}
      sx={{
        alignItems: 'flex-start',
        flexShrink: 0,
        mb: '16px',

        '& .MuiAlert-startDecorator': {
          marginTop: '2px',
        },
      }}
    >
      <Typography level={Level.BODY_SM}>{message}</Typography>
    </Alert>
  );
};
